import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OfferCard from './OfferCard';

function OfferDisplay({ item }) {
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [sectionGap, setSectionGap] = useState(0);
    const [boxGap, setBoxGap] = useState(0);
    const [paddingSide, setPaddingSide] = useState(0);
    const [paddingVert, setPaddingVert] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*18);
        setLineHeight((zoomSize/100)*30);
        setSectionGap((zoomSize/100)*12);
        setBoxGap((zoomSize/100)*8);
        setPaddingVert((zoomSize/100)*12);
        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div 
            style={{ gap: `${sectionGap}px`, paddingTop: `${paddingVert}px`, paddingBottom: `${paddingVert}px` }} 
            className='flex flex-col relative border border-[#E2E2E2] bg-[#FFFFFF78]' 
        >
            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} className='font-medium text-[#212121]'>{item.item.name}</p>

            <div style={{ gap: `${boxGap}px`, paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} className="w-full flex flex-nowrap overflow-x-scroll no-scrollbar">
                {item.item.offersList?.map(offer => {
                    return (
                        <OfferCard 
                            key={offer.id} 
                            offer={offer} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default OfferDisplay;
